import { Link } from '@src/main/modules/common/link/domain/Link';
import { LinkRepository } from '@src/main/modules/common/link/domain/LinkRepository';

export const findLink = async (repository: LinkRepository): Promise<Link> =>
  await repository.findLink();
